import React from 'react'
import { Row, Col, Card, Typography } from 'antd';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import LeadsTable from '../components/Leads/LeadsTable';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAllLeads } from '../store/action/business/LeadAction';
import { getAllAdminLeads } from '../store/action/admin/LeadAdminAction';

const MyLeads = (props) => {
    const { Title } = Typography;
    const [leads, setLeads] = useState([]);
      const [value, setValue] = React.useState('one'); // Track the selected tab
    
      const handleChange = (event, newValue) => {
        setValue(newValue); // Update the selected tab
      };


    useEffect(() => {
        if (props.user && props.user.role) {
            if (props.user.role === 'admin') {
                props.getAllAdminLeads_();
            } else {
                props.getAllLeads_();
            }
        }
    }, []);

    useEffect(() => {
        if (props.user && props.user.role) {
            if (props.user.role === 'admin') {
                setLeads(props.allLeadsAdmin);
            } else {
                setLeads(props.allLeads);
            }
        }
    }, [props.allLeadsAdmin, props.allLeads]);


    return (
        <div style={{ padding: 20 }}>
            <Title level={3}>Leads based on the domain</Title>
            <Tabs value={value} onChange={handleChange} textColor="primary" indicatorColor="primary" aria-label="primary tabs example">
            <Tab value="one" label="Real Estate" />
                <Tab value="two" label="Health Care" />
                <Tab value="three" label="Financial Service" />
                <Tab value="four" label="Manufacturing" />
                <Tab value="five" label="Movers" />
                <Tab value="six" label="E-Commerce" />
            </Tabs>
            {value == 'one' && (
            <Row gutter={20} style={{ marginTop: 20 }}>
            <Col span={24}>
                    <LeadsTable leads={leads} mini={false} expand={true} />
            </Col>
            </Row>
          )}
              {value === 'two' && (
        <Box sx={{p:5}}>
            <h3 style={{textAlign:'center', marginTop:'20px'}}>The Health Care leads table is set to start</h3>
        </Box>
      )}
      {value === 'three' && (
        <Box sx={{p:5}}>
          <h3 style={{textAlign:'center', marginTop:'20px'}}>The Financial Service leads table is set to start</h3>
      </Box>
      )}
      {value === 'four' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Manufacturing leads table is set to start</h3>
       </Box>
      )}
      {value === 'five' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Movers leads table is set to start</h3>
       </Box>
      )}
      {value === 'six' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The E-Commerce leads table is set to start</h3>
       </Box>
      )}   
        </div>
    )
}

const mapStateToProps = state => ({
    user: state.user?.response,
    allLeadsAdmin: state.allLeadsAdmin?.response?.leads || [],
    allLeads: state.allLeads?.response?.leads || []
})

const mapDispatchToProps = dispatch => ({
    getAllLeads_: () => {
        dispatch(getAllLeads());
    },
    getAllAdminLeads_: () => {
        dispatch(getAllAdminLeads());
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyLeads);



// import { Row, Col, Card, Typography } from 'antd';
// import LeadsTable from '../components/Leads/LeadsTable';
// import { useEffect, useState } from 'react';
// import { connect } from 'react-redux';
// import { getAllLeads } from '../store/action/business/LeadAction';
// import { getAllAdminLeads } from '../store/action/admin/LeadAdminAction';

// const MyLeads = (props) => {
//     const { Title } = Typography;
//     const [leads, setLeads] = useState([]);
//     useEffect(() => {
//         if (props.user && props.user.role) {
//             if (props.user.role === 'admin') {
//                 props.getAllAdminLeads_();
//             } else {
//                 props.getAllLeads_();
//             }
//         }
//     }, []);

//     useEffect(() => {
//         if (props.user && props.user.role) {
//             if (props.user.role === 'admin') {
//                 setLeads(props.allLeadsAdmin);
//             } else {
//                 setLeads(props.allLeads);
//             }
//         }
//     }, [props.allLeadsAdmin, props.allLeads]);
//     return (
//         <div style={{ padding: 20 }}>
//             <Title level={2}>My Leads</Title>
//             <Row gutter={20} style={{ marginTop: 20 }}>
//                 <Col span={24}>
//                         <LeadsTable leads={leads} mini={false} expand={true} />
//                 </Col>
//             </Row>
//         </div>
//     )
// }

// const mapStateToProps = state => ({
//     user: state.user?.response,
//     allLeadsAdmin: state.allLeadsAdmin?.response?.leads || [],
//     allLeads: state.allLeads?.response?.leads || []
// })

// const mapDispatchToProps = dispatch => ({
//     getAllLeads_: () => {
//         dispatch(getAllLeads());
//     },
//     getAllAdminLeads_: () => {
//         dispatch(getAllAdminLeads());
//     }
// })

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(MyLeads);
